// extracted by mini-css-extract-plugin
module.exports = {"submitButton":"aX","secondary":"aY","warning":"aZ","outlined":"a0"};